import { usePostJwtLoginIdp } from '@framework/api-client';
import { AuthActions } from '@framework/auth';
import { useTranslation } from '@framework/i18n';
import {
  getNetworkErrorMessage,
  popSessionStorageLocation,
  useHistory,
} from '@framework/ui';
import { message } from 'antd';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ItaliaButton } from '../components/ItaliaButton';

export interface CnsAccessButtonProps {
  fullWidth?: boolean;
}

/**
 * Pulsante CNS
 */
export function CnsLoginButton(props: CnsAccessButtonProps) {
  const { fullWidth } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const login = usePostJwtLoginIdp({});
  const dispatch = useDispatch();
  const history = useHistory();

  const handleLogin = useCallback(async () => {
    setLoading(true);

    try {
      const result = await login.mutateAsync({
        idp: 'cns',
      });
      if (!result.accessToken || !result.refreshToken) {
        console.error('Errore durante il login', result); // prettier-ignore
        message.error(t('user.login.cns-technical-error', 'Si è verificato un errore tecnico durante il login (CNS001).')); // prettier-ignore
        return;
      }

      dispatch(
        AuthActions.loginSucceed({
          strategy: 'jwt',
          accessToken: result.accessToken,
          refreshToken: result.refreshToken,
        }),
      );
      history.push((popSessionStorageLocation() ?? '/') as any);
    } catch (e) {
      console.error(e);
      message.error(
        getNetworkErrorMessage(
          e,
          t(
            'user.login.cns-error',
            "Si e' verificato un errore durante l'accesso tramite CNS. Non è stato possibile recuperare un certificato valido per l'accesso. Verificare i requisiti per l’accesso CNS e riprovare. (CNS002)",
          ),
        ),
      );
    } finally {
      setLoading(false);
    }
  }, [dispatch, history, login, t]);

  return (
    <ItaliaButton
      loading={loading}
      onClick={handleLogin}
      style={fullWidth ? { width: '100%' } : undefined}
      image={require('./img/cns-icon.png')}
      text={t('user.login.cns-button', 'Entra con CNS')}
    />
  );
}
